import {
  //
  ADD_WEBSITE,
  ADD_WEBSITE_FAILURE,
  ADD_WEBSITE_SUCCESS,
  //
  DELETE_WEBSITE,
  DELETE_WEBSITE_FAILURE,
  DELETE_WEBSITE_SUCCESS,
  //
  EDIT_WEBSITE,
  EDIT_WEBSITE_FAILURE,
  EDIT_WEBSITE_SUCCESS,
  //
  FETCH_WEBSITE,
  FETCH_WEBSITE_FAILURE,
  FETCH_WEBSITE_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  OPEN_WEBSITE_ADD_MODAL,
  CLOSE_WEBSITE_ADD_MODAL,
  //
  OPEN_WEBSITE_EDIT_MODAL,
  SET_EDIT_SUCCESS,
  SET_EDIT_FAILURE,
  CLOSE_WEBSITE_EDIT_MODAL,
} from "./constants";

// List
export const fetchWebsite = (payload) => ({
  type: FETCH_WEBSITE,
  payload,
});
export const fetchWebsiteSuccess = (payload) => ({
  type: FETCH_WEBSITE_SUCCESS,
  payload,
});
export const fetchWebsiteFailure = (payload) => ({
  type: FETCH_WEBSITE_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addWebsite = (payload) => ({
  type: ADD_WEBSITE,
  payload,
});
export const addWebsiteSuccess = (payload) => ({
  type: ADD_WEBSITE_SUCCESS,
  payload,
});
export const addWebsiteFailure = (payload) => ({
  type: ADD_WEBSITE_FAILURE,
  payload,
});
// EDIT
export const editWebsite = (payload) => ({
  type: EDIT_WEBSITE,
  payload,
});
export const editWebsiteSuccess = (payload) => ({
  type: EDIT_WEBSITE_SUCCESS,
  payload,
});
export const editWebsiteFailure = (payload) => ({
  type: EDIT_WEBSITE_FAILURE,
  payload,
});
// DELETE
export const deleteWebsite = (payload) => ({
  type: DELETE_WEBSITE,
  payload,
});
export const deleteWebsiteSuccess = (payload) => ({
  type: DELETE_WEBSITE_SUCCESS,
  payload,
});
export const deleteWebsiteFailure = (payload) => ({
  type: DELETE_WEBSITE_FAILURE,
  payload,
});
//
export const openWebsiteAddModal = (payload) => ({
  type: OPEN_WEBSITE_ADD_MODAL,
  payload,
});
export const closeWebsiteAddModal = (payload) => ({
  type: CLOSE_WEBSITE_ADD_MODAL,
  payload,
});
//
export const openWebsiteEditModal = (payload) => ({
  type: OPEN_WEBSITE_EDIT_MODAL,
  payload,
});
export const closeWebsiteEditModal = (payload) => ({
  type: CLOSE_WEBSITE_EDIT_MODAL,
  payload,
});
export const setEditSuccess = (payload) => ({
  type: SET_EDIT_SUCCESS,
  payload,
});
export const setEditFailure = (payload) => ({
  type: SET_EDIT_FAILURE,
  payload,
});
